export default "__VITE_ASSET__ChxIKi7q__"